module.exports = {
          srcSet: __webpack_public_path__ + "0331f7d01a80976d5983b4f1deb2f179-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "0331f7d01a80976d5983b4f1deb2f179-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "0331f7d01a80976d5983b4f1deb2f179-120.png",
          toString:function(){return __webpack_public_path__ + "0331f7d01a80976d5983b4f1deb2f179-120.png"},
          
          width: 120,
          height: 120
        }